import { Col } from 'react-bootstrap'
import { Address } from '../interface/response/Address'
import { ENVIRONMENT } from './constants/UIConstants'

export const getVerticalLine = (index: number) => {
  if (index % 2 === 0) {
    return <Col xs={1} className="custom-line"></Col>
  }
}

export const validLatitude = (latitude: number) => {
  return String(latitude)?.length >= 0 && latitude >= -90 && latitude <= 90
}

export const validLongitude = (longitude: number) => {
  return String(longitude)?.length >= 0 && longitude >= -180 && longitude <= 180
}
export const getInitialLocationObject = (value: Address) => {
  return {
    countryList: [
      {
        countryName: value?.country,
        countryCode: value?.country,
      },
    ],
    stateList: [
      {
        countryName: value?.country,
        countryCode: value?.country,
        stateName: value?.state,
        stateCode: value?.state,
      },
    ],
    cityList: [
      {
        countryCode: value?.country,
        stateCode: value?.state,
        cityCode: value?.city,
        cityName: value?.city,
        freeFormAddress: value?.city,
      },
    ],
    zipCodes: [
      {
        cityCode: value?.city,
        cityName: value?.city,
        freeFormAddress: value?.city,
        postalCode: value?.zipCode,
      },
    ],
    streetList: [
      {
        cityCode: value?.city,
        cityName: value?.city,
        freeFormAddress: value?.city,
        streetName: value?.street,
      },
    ],
  }
}
export const getEnvName = (): string => {
  const currentEnv = process.env.REACT_APP_ENV
  if (!currentEnv || currentEnv === ENVIRONMENT.PROD.ENV_NAME) {
    return ''
  }
  const envKey = (
    currentEnv in ENVIRONMENT ? currentEnv : 'DEV'
  ) as keyof typeof ENVIRONMENT

  return ENVIRONMENT[envKey].ENV_TEXT
}
